import type { TAcceptSpaceTerms, TError } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { getSpaceTermsAcceptanceQueryKey } from './get-space-terms-acceptance';

/**
 * Hook to record the current user's acceptance of a feed space's T&C.
 * On success, invalidates the acceptance query for that space so the gate
 * re-evaluates and unmounts the dialog.
 *
 * @param spaceId - Space ID (UUID)
 */
export const useAcceptSpaceTerms = (spaceId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, TError, TAcceptSpaceTerms>({
    mutationFn: async data => {
      await axios.post(`/community-hub/spaces/${spaceId}/terms-acceptance`, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getSpaceTermsAcceptanceQueryKey(spaceId) });
    },
  });
};
